import StaffType from "./actionTypes"

const INIT_STATE = {
  list: {
    loading: true,
    data: []
  }
}

const Staff = (state = INIT_STATE, action) => {
  switch (action.type) {


    case StaffType.GET_STAFF_LIST_SUCCESS:
      return {
        ...state,
        list: action.payload,
      }

    default:
      return state
  }
}

export default Staff
